import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import dayjs from 'dayjs';

class Component extends BaseComponent {
    shouldComponentUpdate(nextProps) {
        if (nextProps.transits != this.props.transits) {
            return true;
        }

        if (nextProps.route != this.props.route) {
            return true;
        }

        return false;
    }

    render({ transits, route }) {
        if (transits && typeof transits === 'object' && Object.keys(transits).length) {
            return (
                <yearly-forecast-transits>
                    <h6 className='has-margin-15-bottom'>More For Today</h6>
                    { Object.keys(transits).map(key => {
                        const transit = transits[key];
                        const hash = transit.title.toLowerCase().replace(/ /g, '-');
                        return (
                            <div className={`report-item ${route == hash ? 'is-open' : ''}`} id={hash}>
                                <a href={`#${hash}`}>
                                    <h5>{transit.title}</h5>
                                    <h2>{transit.header}</h2>
                                </a>
                                <div className='report-item-content'>
                                    <h6>
                                        Influential Transit Duration:&nbsp;
                                        {dayjs(transit.dates.start).format('MMMM D, YYYY')}
                                        &nbsp;-&nbsp;
                                        {dayjs(transit.dates.end).format('MMMM D, YYYY')}
                                    </h6>
                                    {transit.body.map(p => (<p>{p}</p>))}
                                </div>
                            </div>
                        );
                    })}
                </yearly-forecast-transits>
            );
        }

        return (<yearly-forecast-transits />);
    }
}

const mapStateToProps = (state) => ({
    transits: state.transits,
    route: state.route,
});

export default connect(mapStateToProps)(Component);
